import { PropsWithChildren, JSX } from 'react';

import * as styles from './styles';

type CheckboxFieldProps = PropsWithChildren<
  JSX.IntrinsicElements['input'] & {
    label?: string;
    onChange: () => void;
    forceOnlyText?: boolean;
  }
>;

export const CheckboxField = ({
  checked,
  name,
  onChange,
  className,
  children,
  forceOnlyText = false,
  ...props
}: CheckboxFieldProps) => {
  const hasChildren = Boolean(children);

  const checkbox = (
    <input
      {...props}
      type="checkbox"
      name={name}
      data-testid={`${name} checkbox`}
      className={className}
      css={styles.checkbox}
      checked={checked}
      onChange={onChange}
    />
  );

  if (!hasChildren) return checkbox;

  return (
    <label
      css={styles.checkboxLabel(forceOnlyText || typeof children === 'string')}
      role="presentation"
      onKeyDown={e => e.key === 'Enter' && onChange()}
    >
      {checkbox}
      {children}
    </label>
  );
};
